import React, { useState, useEffect, useCallback } from "react";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
  dotNumberBlurValidation,
  dotNumberValidation,
  withDotValidation,
} from "../../../../../../helpers/global_helper";
import BetSuccessPopup from "../../../../../Popups/BetSuccessPopup";
import ConfirmBetDeskonPopup from "../../../../../Popups/ConfirmBetDeskonPopup";
import ErrorInnerPopup from "../../../../../Popups/ErrorInnerPopup";
import ErrorPopup from "../../../../../Popups/ErrorPopup";
import { useDispatch, useSelector } from "react-redux";
import { setCommonConfig } from "../../../../../../redux/actions";
import CancelledBetDeskonPopup from "../../../../../Popups/CancelledBetDeskonPopup";
import {
  formatPrice,
  formatPricewithdecimal,
} from "../../../../../NumberFormat";
import { withTranslation } from "react-i18next";
import { getUserBalance } from "../../../../../../redux/actions";
import GameClosedPopup from "../../../GameClosedPopup";
import MarketClose from "../../../MarketClose";
import { BBPayAmountCount } from "../../BBPayAmountCount";

const PolaTarung_Bet_Deskon = (props) => {
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const dispatch = useDispatch();
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const [as, setAs] = useState("");
  const [kop, setKop] = useState("");
  const [kepala, setKepala] = useState("");
  const [ekor, setEkop] = useState("");
  const [showTable, setShowTable] = useState(true);
  const [probabilityTable, setProbabilityTable] = useState(true);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const game_sub_child_type = useSelector((state) => state.GameSubType.game_sub_child_type);
  const [multipleValue, setMultipleValue] = useState('');

  const [inputValues, setInputValues] = useState({
    as: "",
    kop: "",
    kepala: "",
    ekor: "",
    betdata: [],
  });

  useEffect(() => {
    dispatch(setCommonConfig({ key: "gameType", value: "polatarung" }));
  }, []);

  const [inputDisabled, setInputDisabled] = useState(false);

  const [dummyData, setDummyData] = useState([]);
  const [showInstruction, setShowInstruction] = useState(true);
  const [disabled, setDisabled] = useState(true);
  const handleDisabledChange = useCallback((event) => {
    setDisabled(event.value);
  }, []);
  const [respData, setRespData] = useState([]);
  const [successPopup, setSuccessPopup] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);
  const [angaka, setAngaka] = useState([]);
  const [newBetNum, setNewBetNum] = useState([]);
  const [reqData, setReqData] = useState({
    gameId: gameId,
    gameType: "polatarung",
    betTogelAuth: "betTogelAuth",
    dataangka: [],
    databet: [],
    allowPartner: "allowPartner",
  });

  const [popupData, setpopupData] = useState({
    isfullbet: 0,
    gameId: gameId,
    gameType: "polatarung",
    dfp: "diskon",
    betTogelAuth: "betTogelAuth",
    dataangka: [],
    databet: [],
    allowPartner: "allowPartner",
  });

  useEffect(() => {
    // Update reqData and popupData when gameId changes
    setReqData((prevReqData) => ({
      ...prevReqData,
      gameId: gameId,
    }));

    setpopupData((prevPopupData) => ({
      ...prevPopupData,
      gameId: gameId,
    }));
  }, [gameId]);

  useEffect(() => {
    let multiple = '';
    if (game_sub_child_type === 'DISCOUNT') {
      multiple = betDiscount.showMultiple;
    } else if (game_sub_child_type === 'FULLBET') {
      multiple = betDiscount.showMultipleFullbet;
    } else {
      multiple = betDiscount.showMultiple;
    }
    setMultipleValue(multiple);
  }, [game_sub_child_type]);

  useEffect(() => {
    setCheckedBoxes(Array(dummyData.length).fill(true));
  }, [dummyData]);
  useEffect(() => {
    passData();
  }, [reqData.dataangka]);

  const [rows, setRows] = useState([
    {
      "4D": "",
      "3D Depan": "",
      "3D Belakang": "",
      "2D Depan": "",
      "2D Tengah": "",
      "2D Belakang": "",
    },
  ]);

  useEffect(() => {
    if (Object.keys(betDiscount).length <= 0) {
      setErrorMessage("Togel Data API missing, Refresh page and try again.");
      setShowErrorPopup(true);
      return;
    }
  }, [betDiscount]);

  // const handleCellChange = (e, rowIndex, key) => {
  //   const numericValue = e.target.value.replace(/\D/g, '');

  //   makeAjax(url.TOGEL_API.getTogelDetails, { "gameId": gameId, "gameType": "polatarung" })
  //     .then((response) => {
  //       if (validateInput(key, numericValue, response)) {
  //         const updatedRows = [...rows];
  //         updatedRows[rowIndex][key] = numericValue;
  //         setRows(updatedRows);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching price response:", error);
  //       setShowErrorPopup(true);
  //       setErrorMessage("Error fetching price response");
  //     });
  // };

  const handleCellBlur = (e, rowIndex, key) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let minValue = '';
    if (key === "4D") {
      minValue = betDiscount.showMin4d;
    }
    if (key === "3D Depan") {
      minValue = betDiscount.showMin3dDepan;
    }
    if (key === "3D Belakang") {
      minValue = betDiscount.showMin3dBelakang;
    }
    if (key === "2D Depan") {
      minValue = betDiscount.showMin2dDepan;
    }
    if (key === "2D Tengah") {
      minValue = betDiscount.showMin2dTengah;
    }
    if (key === "2D Belakang") {
      minValue = betDiscount.showMin2dBelakang;
    }

    let regex = '';
    if (String(minValue).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    e.target.value = value;
    handleCellChange(e, rowIndex, key);
  }

  const handleCellChange = useCallback(
    (e, rowIndex, key) => {
      let value = e.target.value;
      value = value.replace(',', '.');
      let minValue = '';
      if (key === "4D") {
        minValue = betDiscount.showMin4d;
      }
      if (key === "3D Depan") {
        minValue = betDiscount.showMin3dDepan;
      }
      if (key === "3D Belakang") {
        minValue = betDiscount.showMin3dBelakang;
      }
      if (key === "2D Depan") {
        minValue = betDiscount.showMin2dDepan;
      }
      if (key === "2D Tengah") {
        minValue = betDiscount.showMin2dTengah;
      }
      if (key === "2D Belakang") {
        minValue = betDiscount.showMin2dBelakang;
      }

      let regex = '';
      if (String(minValue).length === 3) {
        regex = /^\d*([.,]\d?)?$/;
        value = dotNumberValidation(value);
      } else {
        regex = /^\d*$/;
        value = withDotValidation(value);
      }
      if (regex.test(value)) {
        const updatedRows = [...rows];
        updatedRows[rowIndex][key] = value;
        setRows(updatedRows);
      }
    },
    [rows]
  );

  const validateInput = (key, numericValue) => {
    if (numericValue == "") return true;

    if (key === "4D" && numericValue > betDiscount.showMax4d / 1000) {
      setShowErrorPopup(true);
      setErrorMessage(props.t("you_have_reached_max_bet_value"));
      return false;
    }
    if (
      key === "3D Depan" &&
      numericValue > betDiscount.showMax3dDepan / 1000
    ) {
      setShowErrorPopup(true);
      setErrorMessage(props.t("you_have_reached_max_bet_value"));
      return false;
    }
    if (
      key === "3D Belakang" &&
      numericValue > betDiscount.showMax3dBelakang / 1000
    ) {
      setShowErrorPopup(true);
      setErrorMessage(props.t("you_have_reached_max_bet_value"));
      return false;
    }
    if (
      key === "2D Depan" &&
      numericValue > betDiscount.showMax2dDepan / 1000
    ) {
      setShowErrorPopup(true);
      setErrorMessage(props.t("you_have_reached_max_bet_value"));
      return false;
    }
    if (
      key === "2D Tengah" &&
      numericValue > betDiscount.showMax2dTengah / 1000
    ) {
      setShowErrorPopup(true);
      setErrorMessage(props.t("you_have_reached_max_bet_value"));
      return false;
    }
    if (
      key === "2D Belakang" &&
      numericValue > betDiscount.showMax2dBelakang / 1000
    ) {
      setShowErrorPopup(true);
      setErrorMessage(props.t("you_have_reached_max_bet_value"));
      return false;
    }

    // if (key === "4D" && numericValue < betDiscount.showMin4d / 1000) {
    //   setShowErrorPopup(true);
    //   setErrorMessage(props.t("minimum_bet_is_1"));
    //   return false;
    // }
    // if (
    //   key === "3D Depan" &&
    //   numericValue < betDiscount.showMin3dDepan / 1000
    // ) {
    //   setShowErrorPopup(true);
    //   setErrorMessage(props.t("minimum_bet_is_1"));
    //   return false;
    // }
    // if (
    //   key === "3D Belakang" &&
    //   numericValue < betDiscount.showMin3dBelakang / 1000
    // ) {
    //   setShowErrorPopup(true);
    //   setErrorMessage(props.t("minimum_bet_is_1"));
    //   return false;
    // }
    // if (
    //   key === "2D Depan" &&
    //   numericValue < betDiscount.showMin2dDepan / 1000
    // ) {
    //   setShowErrorPopup(true);
    //   setErrorMessage(props.t("minimum_bet_is_1"));
    //   return false;
    // }
    // if (
    //   key === "2D Tengah" &&
    //   numericValue < betDiscount.showMin2dTengah / 1000
    // ) {
    //   setShowErrorPopup(true);
    //   setErrorMessage(props.t("minimum_bet_is_1"));
    //   return false;
    // }
    // if (
    //   key === "2D Belakang" &&
    //   numericValue < betDiscount.showMin2dBelakang / 1000
    // ) {
    //   setShowErrorPopup(true);
    //   setErrorMessage(props.t("minimum_bet_is_1"));
    //   return false;
    // }
    return true;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/\D/g, "");
    const digits = numericValue.split("");
    const hasRepeatedDigits = digits.some(
      (digit, index) => digits.indexOf(digit) !== index
    );
    const maxLength = 7;
    if (numericValue.length > maxLength) {
      setShowErrorPopup(true);
      setErrorMessage(props.t("maximum_7_digits"));
      return;
    }
    if (hasRepeatedDigits) {
      setShowErrorPopup(true);
      setErrorMessage(props.t("betting_number_repeat"));
      return;
    }
    setInputValues((prevState) => ({
      ...prevState,
      [name]: numericValue,
    }));
    if (inputValues.betdata) {
      const betdata = [...inputValues.betdata];
      const existingIndex = betdata.findIndex((item) =>
        item.startsWith(`${name}-`)
      );
      if (existingIndex !== -1) {
        betdata[existingIndex] = `${name}-${numericValue}`;
      } else {
        betdata.push(`${name}-${numericValue}`);
      }
      setInputValues((prevState) => ({
        ...prevState,
        betdata,
      }));
    }
  };

  useEffect(() => {
    const updatedDatabet = ["as", "kop", "kepala", "ekor"].map((field) => {
      const existingBet = inputValues.betdata?.find((item) =>
        item.startsWith(`${field}-`)
      );
      return existingBet ? existingBet : `${field}- `;
    });
    setReqData((prev) => ({
      ...prev,
      databet: updatedDatabet,
    }));
  }, [inputValues]);

  useEffect(() => {
    handleReset();
  }, [gameId]);

  const handleReset = () => {
    setInputValues({
      as: "",
      kop: "",
      kepala: "",
      ekor: "",
      betdata: [],
    });
    setRows([
      {
        as: true,
        kop: true,
        kepala: true,
        ekor: true,
        "4D": "",
        "3D Depan": "",
        "3D Belakang": "",
        "2D Depan": "",
        "2D Tengah": "",
        "2D Belakang": "",
      },
    ]);
    const clearedRows = rows.map((row) =>
      Object.fromEntries(Object.entries(row).map(([key, _]) => [key, ""]))
    );
    setRows(clearedRows);
    setDisabled(true);
  };
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const submitProcess = () => {
    const allValuesEmpty = rows.every((rowData) =>
      Object.values(rowData).every((value) => value === "")
    );

    if (allValuesEmpty) {
      setErrorMessage(props.t("guess_bet_wrong"));
      setShowErrorPopup(true);
      return;
    }

    const newDataAngka = [];
    rows.forEach((rowData, index) => {
      Object.keys(rowData).forEach((key) => {
        if (rowData[key]) {
          const transformedKey = key.toLowerCase().replace(/\s+/g, "-");
          newDataAngka.push([
            transformedKey,
            rowData[key] * multipleValue,
            "success",
          ]);
        } else {
          newDataAngka.push([`${key.toLowerCase()}`, null, "null"]);
        }
      });
    });

    setReqData((prev) => ({
      ...prev,
      dataangka: newDataAngka,
    }));
  };

  useEffect(() => {
    if (reqData.dataangka && reqData.databet) {
      if (reqData.dataangka.length > 0 && reqData.databet.length > 0) {
        const allInputsDisabled = Object.values(enabledInputs).every(
          (value) => !value
        );
        if (allInputsDisabled) {
          setErrorMessage(props.t("guess_bet_wrong"));
          setShowErrorPopup(true);
          return;
        }
        makeAjax(url.TOGEL_API.processPolaTarung, reqData).then((response) => {
          if (response.status !== respStatus["SUCCESS"]) {
            if (response.code === "sub_game_status_close") {
              setShowGameClose(true);
              showMessage(false);
              hideCommonToaster();
              dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
              return;
            }
            if (response.code === "market_close_err") {
              setShowMarketClose(true);
              showMessage(false);
              hideCommonToaster();
              dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
              return;
            }

            if (response.code !== "validation_error") {
              setErrorMessage(props.t(response.code));
              setShowErrorPopup(true);
              return;
            }
            setErrorMessage(props.t("guess_bet_wrong"));
            setShowErrorPopup(true);
            return;
          }
          const newData = [];
          setNewBetNum(response.data.betnumber);

          let newBeliAmt = 0
          Object.entries(response.data.betnumber).forEach(([key, numbers]) => {
            const tebak = `${numbers.join(" : ")} ( ${key
              .replace(/-/g, " ")
              .replace(/\b\w/g, (c) => c)} )`;
            const betAmountEntry = reqData.dataangka.find(
              (entry) => entry[0] === key
            );
            const beliAmount = betAmountEntry ? betAmountEntry[1] : 1000;
            if (key == "4d") {
              newBeliAmt = BBPayAmountCount(beliAmount, betDiscount.showDisc4d)
            }
            else if (key == "3d-depan" || key == "3d-belakang") {
              newBeliAmt = BBPayAmountCount(beliAmount, betDiscount.showDisc3d)
            }
            else if (key == "2d-belakang" || key == "2d-depan" || key == "2d-tengah") {
              newBeliAmt = BBPayAmountCount(beliAmount, betDiscount.showDisc2d)
            }

            const formattedValue = newBeliAmt * numbers.length;

            const beli = `${newBeliAmt.toLocaleString()} X ${numbers.length
              } = ${formattedValue.toLocaleString()}`;
            const count = numbers.length;

            newData.push({
              no: newData.length + 1,
              tebak: tebak.toUpperCase(),
              beli: beli,
              count: count,
            });
          });

          setDummyData(newData);
          setShowTable(true);
          setShowInstruction(false);
        });
      }
    } else {
      setErrorMessage(props.t("guess_bet_wrong"));
      setShowErrorPopup(true);
    }
    handleEnabled();
  }, [reqData.dataangka]);
  const handleEnabled = () => {
    setEnabledInputs({
      as: true,
      kop: true,
      kepala: true,
      ekor: true,
      "4D": false,
      "3D Depan": false,
      "3D Belakang": false,
      "2D Depan": false,
      "2D Tengah": false,
      "2D Belakang": false,
    });
  };
  const calculateTotalPayment = () => {
    let total = 0;
    
    console.log("dummyData", dummyData);
    dummyData.forEach((item) => {
      const beli = parseFloat(item.beli.split("=")[1].replace(/[^\d.]/g, ""));
      total += beli;
    });
    console.log("total", total);
    
    return formatPrice(total);
  };

  const convertDatabet = () => {
    if (reqData.databet) {
      let defaultValues = {
        as: "0",
        kepala: "0",
        kop: "0",
        ekor: "0",
      };
      reqData.databet.forEach((item) => {
        const [key, value] = item.split("-");
        if (key in defaultValues) {
          defaultValues[key] = value.trim() || "0";
        }
      });
      const { as, kepala, kop, ekor } = defaultValues;
      return { as, kepala, kop, ekor };
    }
  };
  const [checkedBoxes, setCheckedBoxes] = useState(
    Array(dummyData.length).fill(true)
  );

  const handleCheckboxToggle = (index) => {
    const newCheckedBoxes = [...checkedBoxes];
    newCheckedBoxes[index] = !newCheckedBoxes[index];
    setCheckedBoxes(newCheckedBoxes);
  };
  const newDataBet = convertDatabet();

  const passData = () => {
    setpopupData((prevState) => ({
      ...prevState,
      dataangka: [...reqData.dataangka],
      databet: newDataBet,
    }));
  };

  const showPopup = (event) => {
    const checkedDataAngka = reqData.dataangka.filter(
      (_, index) => checkedBoxes[index]
    );
    if (checkedDataAngka.length == 0) {
      setErrorMessage(props.t("guess_bet_wrong"));
      setShowErrorPopup(true);
      return;
    }
    setShowConfirmationPopup(true);
  };
  const submitProcessOk = () => {
    setShowConfirmationPopup(false);
    let filteredData = popupData.dataangka.filter((arr) =>
      arr.every((item) => item !== null && item !== "null")
    );
    let betTypes = Object.keys(newBetNum);
    let finalFilteredData = filteredData.filter((arr) =>
      betTypes.includes(arr[0])
    );
    const checkedDataAngka = finalFilteredData.filter(
      (_, index) => checkedBoxes[index]
    );
    if (popupData && checkedDataAngka.length > 0) {
      makeAjax(url.TOGEL_API.process4D3D2D, {
        ...popupData,
        dataangka: checkedDataAngka,
      }).then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }

          if (response.code !== "validation_error") {
            setErrorMessage(props.t(response.code))
            setShowErrorPopup(true);
            return;
          }
          setErrorMessage(props.t("guess_bet_wrong"));
          setShowErrorPopup(true);
          return;
        }
        setRespData((prevData) => [...prevData, response.data]);
        dispatch(getUserBalance());
        setSuccessPopup(true);
        setShowTable(false);
      });
    } else {
      setErrorMessage(props.t("guess_bet_wrong"));
      setShowErrorPopup(true);
      return;
    }
  };

  const [enabledInputs, setEnabledInputs] = useState({
    "4D": false,
    "3D Depan": false,
    "3D Belakang": false,
    "2D Depan": false,
    "2D Tengah": false,
    "2D Belakang": false,
  });
  useEffect(() => {
    setEnabledInputs({
      "4D":
        inputValues.as &&
        inputValues.kop &&
        inputValues.kepala &&
        inputValues.ekor,
      "3D Depan": inputValues.as && inputValues.kop && inputValues.kepala,
      "3D Belakang": inputValues.kop && inputValues.kepala && inputValues.ekor,
      "2D Depan": inputValues.as && inputValues.kop,
      "2D Tengah":
        (inputValues.kop && inputValues.kepala) ||
        (inputValues.as && inputValues.kop && inputValues.kepala),
      "2D Belakang":
        (inputValues.kepala && inputValues.ekor) ||
        (inputValues.kop && inputValues.kepala && inputValues.ekor),
    });
  }, [inputValues.as, inputValues.kop, inputValues.kepala, inputValues.ekor]);
  const handleClose = () => {
    setSuccessPopup(false);
    setRespData([]);
    handleReset();
    setShowInstruction(true);
  };
  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (showErrorPopup && e.key === "Tab") {
        e.preventDefault();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [showErrorPopup]);

  return (
    <div className="polaTarung_wrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          <div className="first_section">
            <div className="sub_section">
              <label htmlFor="">AS</label>
              <input
                type="text"
                name="as"
                value={inputValues.as}
                inputMode="numeric"
                pattern="[0-9]*"
                disabled={enabledInputs.as}
                onChange={handleChange}
              />
            </div>
            <div className="sub_section">
              <label htmlFor="">KOP</label>
              <input
                type="text"
                name="kop"
                value={inputValues.kop}
                inputMode="numeric"
                pattern="[0-9]*"
                disabled={enabledInputs.kop}
                onChange={handleChange}
              />
            </div>
            <div className="sub_section">
              <label htmlFor="">KEPALA</label>
              <input
                type="text"
                name="kepala"
                value={inputValues.kepala}
                inputMode="numeric"
                pattern="[0-9]*"
                disabled={enabledInputs.kepala}
                onChange={handleChange}
              />
            </div>
            <div className="sub_section">
              <label htmlFor="">EKOR</label>
              <input
                type="text"
                name="ekor"
                value={inputValues.ekor}
                inputMode="numeric"
                pattern="[0-9]*"
                disabled={enabledInputs.ekor}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="polatarung_grid_table">
            {rows.map((rowData, index) => (
              <React.Fragment key={index}>
                {Object.keys(rowData).map((keys, rowIndex) => (
                  <div className="pola_grid_item" key={rowIndex}>
                    <div className="pola_grid_row">
                      <p>&nbsp;</p>
                      <p>{keys}</p>
                    </div>
                    <div className="pola_grid_row row2">
                      <p>{props.t('buy')}</p>
                      <input
                        type="text"
                        value={rowData[keys]}
                        onChange={(e) => handleCellChange(e, index, keys)}
                        onBlur={(e) => handleCellBlur(e, index, keys)}
                        placeholder="Bet"
                        disabled={!enabledInputs[keys]}
                        inputMode="decimal"
                        pattern="[0-9]*[.,]?[0-9]**"
                      />
                    </div>
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
          <div className="btn_section">
            <ul className="button-list">
              <li>
                <button className="reset" onClick={handleReset}>
                  {props.t('reset')}
                </button>
              </li>
              <li>
                <button className="submit" onClick={submitProcess}>
                  {props.t('submit')}
                </button>
              </li>
            </ul>
          </div>
          {showInstruction && (
            <div className="Instruction_section">
              <p>{props.t("how_to_use_polatarung")}:</p>
              <p>{props.t("polataring_quickbuy")}</p>
              <p>1. {props.t("how_to_use_polatarung_instruction_1")}</p>
              <p>2. {props.t("how_to_use_polatarung_instruction_2")}</p>
              <p>3. {props.t("how_to_use_polatarung_instruction_3")}</p>
              <p>{props.t("polatarung_purchase_instruction_1")}</p>
              <p>{props.t("polatarung_purchase_instruction_2")}</p>
            </div>
          )}

          {showTable && dummyData.length > 0 && probabilityTable && (
            <div className="polaTarung_probability_container">
              <div className="probability_container">
                <table>
                  <thead>
                    <tr className="Heading">
                      <th style={{ width: "46px" }}>No.</th>
                      <th style={{ width: "46px" }}></th>
                      <th>Tebak</th>
                      <th style={{ textAlign: "center" }}>Beli</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dummyData.map((value, index) => (
                      <tr key={index}>
                        <td style={{ textAlign: "center" }}>{index + 1}</td>
                        <td align="center">
                          <input
                            type="checkbox"
                            className="chk_bb"
                            checked={checkedBoxes[index]}
                            defaultChecked
                            onChange={() => handleCheckboxToggle(index)}
                          />
                          <span style={{ textAlign: "center", display: "block" }}>
                            {value.count}
                          </span>
                        </td>
                        <td
                          className="bet_probability_column"
                          style={{
                            display: "block",
                            textAlign: "left",
                            fontFamily: "sans-serif",
                          }}
                        >
                          {value.tebak}
                        </td>
                        <td style={{ textAlign: "right" }}>{value.beli}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="btn_section1">
                <ul className="button-list1">
                  <li>
                    <button className="submit" onClick={showPopup}>
                      Submit
                    </button>
                  </li>
                </ul>
                <div className="total_bayar_txt">
                  Total Pay :{" "}
                  <span>{calculateTotalPayment().toLocaleString()}</span>
                </div>
              </div>
            </div>
          )}
          {showConfirmationPopup && (
            <ConfirmBetDeskonPopup
              onClose={hanldeConfirmationPopupClose}
              submitProcessOk={submitProcessOk}
            />
          )}
          {showCancelledPopup && (
            <CancelledBetDeskonPopup onClose={() => setShowCanclledPopup(false)} />
          )}
          {successPopup && (
            <div className="popup-overlay ">
              <BetSuccessPopup response={respData} onClose={handleClose} />
            </div>
          )}
          {
            /*---error popup --*/
            showErrorPopup && (
              <ErrorInnerPopup
                modalTitle={""}
                modalHeader={true}
                onCloseModal={() => setShowErrorPopup(false)}
              >
                <ErrorPopup
                  message={errMessage}
                  onClose={() => setShowErrorPopup(false)}
                />
              </ErrorInnerPopup>
            )
          }
        </>
      )}



    </div>
  );
};
export default withTranslation()(PolaTarung_Bet_Deskon);
